import { getDripFormTemplate, getVueDripTemplate } from "../../shortcodes/templates";

let dripForm = null;
const visualizeDripComponents = content => {
  dripForm = content.querySelectorAll('[data-tiny-mce-component="dripform"]');
  if (dripForm.length > 0) {
    dripForm.forEach(item => {
      item.innerHTML = getDripFormTemplate({
        title: item.querySelectorAll("[title]")[0].getAttribute("title"),
        subtitle: item.querySelectorAll("[subtitle]")[0].getAttribute("subtitle"),
        buttonText: item.querySelectorAll("[button-text]")[0].getAttribute("button-text"),
      });
    });
  }
};

let initDripHtmlNode = null;
const serializeDripComponents = content => {
  initDripHtmlNode = content.querySelectorAll('[data-tiny-mce-component="dripform"]');
  if (initDripHtmlNode.length > 0) {
    initDripHtmlNode.forEach(item => {
      const dripFormData = {
        title: item.querySelectorAll('[data-tiny-mce-component-data="title"]')[0]?.innerHTML,
        subtitle: item.querySelectorAll('[data-tiny-mce-component-data="subtitle"]')[0]?.innerHTML,
        buttonText: item.querySelectorAll('[data-tiny-mce-component-data="button-text"]')[0]?.innerHTML,
      };
      item.innerHTML = getVueDripTemplate(dripFormData);
    });
  }
};

export { visualizeDripComponents, serializeDripComponents };
